import React from 'react'

import LabelTitleText from 'components/shared/LabelTitleText'
import Layout from 'components/shared/Layout'
import GradientHeader from 'components/shared/GradientHeader'
import CardsGrid from 'components/shared/CardsGrid'

import css from './styles.module.scss'

const RelatedArticlesGrid = ({
  gradientHeader,
  intro,
  cards,
  articles,
  bottomLink,
  singleColumnOnTablet = true,
  customCardProps,
  customCardComponent,
}) => {
  return (
    <div className={css.RelatedArticlesGrid}>
      <Layout type="maxWidth">
        <GradientHeader {...gradientHeader} className={css.header}>
          {intro && (
            <div className={css.headerWrapper}>
              <div className={css.content}>
                <LabelTitleText center {...intro} />
              </div>
            </div>
          )}
        </GradientHeader>
        <Layout type="wrapper">
          <Layout type="innerWrapper" className={css.innerWrapper}>
            <CardsGrid
              bottomLink={bottomLink}
              cards={articles || cards}
              singleColumnOnTablet={singleColumnOnTablet}
              customCardComponent={customCardComponent}
              customCardProps={{
                ...customCardProps,
                isList: false,
                cover: {
                  size: 'large',
                },
              }}
            />
          </Layout>
        </Layout>
      </Layout>
    </div>
  )
}

export default RelatedArticlesGrid
